import { Modal, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import GetIssueFields from './get-issue-fields';


function TicketForm({ ticketForm, setTicketForm, handleTicketSubmit, handleTicketClose }) {
  const [ticketData, setTicketData] = useState([]);
  const hiddenFields = ['reporter', 'project'];
  const handleClose = () => {
    handleTicketClose();
  };
  const handleSubmit = () => {
    const hasErrors = ticketData.some(
      (fieldData) => fieldData?.required && !fieldData?.value
    );
    if (hasErrors) {
      const updatedTicketData = ticketData.map((fieldData) => {
        if (fieldData?.required && !fieldData?.value) {
          return {
            ...fieldData,
            errorMessage: 'Please provide a value for required field.',
          };
        }
        return fieldData;
      });
      setTicketData(updatedTicketData);
      return;
    }

    handleTicketSubmit(ticketData.filter((el)=>el.value), ticketForm?.data);
    setTicketForm({ isOpen: false, isLoading: false, data: null });
  };
  useEffect(() => {
    if (ticketForm?.isOpen && !ticketForm?.isLoading) {
      const summaryField = ticketForm?.data?.items?.find(
        (field) => field.key === 'summary'
      );
      const fields = ticketForm?.data?.items?.filter(
        (field) => field.key !== 'summary' && !hiddenFields?.includes(field?.key)
      );
      const formattedFields = fields?.map((field) => {
        return {
          field,
          fieldKey: field.key || field.fieldId,
          value: null,
          required: field?.required,
          errorMessage:''
        };
      });

      setTicketData([
        {
          value: ticketForm?.data?.description,
          required: summaryField?.required,
          fieldKey: 'summary',
          field: summaryField,
          errorMessage:''
        },
        ...formattedFields,
      ]);
    }
  }, [ticketForm]);

  const updateFieldValue = (e,field) => {
    const updateFields = ticketData?.map((fieldData) => {
      if (fieldData?.fieldKey === field?.fieldKey) {
        let value = e.value;
        if(e?.field?.schema?.custom && e?.field?.schema?.type === 'option'){
          value = { id: value };
        }
        return {
          ...fieldData,
          value: value,
          errorMessage:''
        };
      }
      return fieldData;
    });
    setTicketData(updateFields);
    
  }

  return (
    <Modal
      centered
      title={'Ticket Form'}
      open={ticketForm?.isOpen}
      closeIcon={<CloseOutlined onClick={() => handleClose()} />}
      okText="Create Ticket"
      onCancel={() => {
        handleClose(ticketData);
      }}
      onOk={() => {
        handleSubmit();
      }}
    >
      {ticketForm?.isLoading ? (
        <div
          size="large"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '10vh',
            width: '100%',
          }}
        >
          <Spin spinning={true} />
        </div>
      ) : (
        <Row gutter={[16, 16]}>
          {ticketData?.map((fieldData) => {
            const { field, value } = fieldData;
            if (!field.key) {
              field.key = field.fieldId;
            }
            const isAllowedValueEmpty =
              field.allowedValues && field.allowedValues.length === 0
                ? true
                : false;
            let isFieldHidden = false;

            if (
              // field.key !== 'issuetype' &&
              field.key !== 'attachment' &&
              field.key !== 'project' &&
              !(
                field.schema &&
                (field.schema.custom ==
                  'com.pyxis.greenhopper.jira:gh-lexo-rank' ||
                  field.schema.custom ==
                    'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf')
              ) &&
              !isFieldHidden &&
              !isAllowedValueEmpty
            ) {
              let initialValue = value;
              if (field?.schema?.custom && field?.schema?.type === 'option') {
                initialValue = value?.id;
              }
              // field.key === 'summary' ? ticketForm?.data?.description : '';
              return (
                <>
                  <GetIssueFields
                    appKey={'jira'}
                    field={field}
                    key={field.key}
                    // bot={bot}
                    initialValue={initialValue}
                    fieldData={fieldData}
                    onFieldChange={(e) => updateFieldValue(e, fieldData)}
                    appInstanceId={ticketForm?.data?.appInstanceId}
                    data={ticketForm?.data}
                    projectId={ticketForm?.data?.projectId}
                  />
                </>
              );
            }
          })}
        </Row>
      )}
    </Modal>
  );
}

export default TicketForm;
